import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import Shimmer from '@techsoftware/happay-widgets/Shimmer';
import { isMobile } from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import ContainerShimmer from '../../ContainerView/containerShimmer';

export default function InvoiceShimmer() {
  return (
    <Grid
      container
      justify="flex-start"
      alignItems="flex-start"
      className="margin-t-118 detail-container"
    >
      <Grid
        item
        className="invoice-upload-container"
        xs={24}
        sm={10}
        md={10}
        xl={10}
        lg={10}
      >
        <div className={isMobile ? 'margin-b-20' : 'margin-r-36'}>
          <Shimmer shimmerStyle={{ width: '100%', height: '80vh' }} />
        </div>
      </Grid>
      <Grid item xs={24} sm={14} md={14} xl={14} lg={14}>
        <ContainerShimmer count={6} />
        <ContainerShimmer count={6} />
      </Grid>
    </Grid>
  );
}
